import React from 'react';
import { cloneDeep, isEmpty } from 'lodash';

import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import Modal from '@material-ui/core/Modal';

import ACButton from '../../atoms/ACButton';
import ACSelect from '../../atoms/ACSelect';

import styles from './SetPlaces.module.scss';

export default class SetPlaces extends React.Component {
  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false);
  }

  onKeyDown = (event) => {
    if (event.keyCode === 27) {
      //Escape key
      this.props.onCloseFunc();
    }
  };

  onSavePlaces() {
    const notification = this.checkForErrors();
    if (isEmpty(notification)) {
      // TODO: Implement Me for save
    } else {
      // TODO: Implement Me with error message
    }
  }

  onDeletePlaces = (type) => {
    this.props.onDeletePlacesFunc(type);
    this.props.onCloseFunc();
  };

  onDeletePlace = (place) => {
    this.props.onDeletePlaceFunc(place);
  };

  onChangePlaceType = (name, type) => {
    if (isEmpty(name)) return;
    this.props.onChangeTypeFunc(type);
  };

  onInputChangePlace = (query) => {
    const { onInputChangePlaceFunc, selectedType } = this.props;
    if (isEmpty(query)) return null;
    onInputChangePlaceFunc(selectedType, query);
  };

  onChangePlace = (name, place) => {
    if (isEmpty(name)) return;
    this.props.onChangePlaceFunc(place);
  };

  checkForErrors() {
    const { selectedPlaces, selectedType } = cloneDeep(this.props);
    const errors = [];
    let isError = false;
    let notification = {};
    if (isEmpty(selectedPlaces)) {
      errors.push('Please select a place.');
      isError = true;
    }
    if (isEmpty(selectedType)) {
      errors.push('Please select a type.');
      isError = true;
    }
    notification = { errors, isError };
    return notification;
  }

  renderTopPanel(showDeleteIcon, type) {
    let deleteIcon = <div />;
    if (showDeleteIcon === true) {
      deleteIcon = (
        <div className={styles.topBarIcon}>
          <DeleteIcon
            style={{
              color: '#FF765F',
            }}
            onClick={() => this.onDeletePlaces(type)}
          />
        </div>
      );
    }

    return (
      <div className={styles.top}>
        <div>
          <h3>Set Places</h3>
        </div>
        {deleteIcon}
        <div
          className={styles.topBarIcon}
          style={{
            marginRight: '0',
          }}
        >
          <CloseIcon onClick={this.props.onCloseFunc} />
        </div>
      </div>
    );
  }

  renderTypes() {
    const { types = [], selectedType = {} } = cloneDeep(this.props);
    const placeType = types.find((type) => {
      return type.value === selectedType.value;
    });

    if (isEmpty(types)) return <div />;

    return (
      <div className={styles.selectContainer}>
        <span className={styles.adornment}>Type</span>
        <ACSelect
          name="type"
          showLabel={false}
          options={types}
          option={placeType}
          optionLabel="name"
          optionValue="value"
          onChangeFunc={this.onChangePlaceType}
        />
      </div>
    );
  }

  renderPlaces() {
    const { places = [] } = cloneDeep(this.props);

    if (isEmpty(places)) return <div />;

    return (
      <div className={styles.selectContainer}>
        <span className={styles.adornment}>Places</span>
        <ACSelect
          name="place"
          showLabel={false}
          options={places}
          optionLabel="name"
          optionValue="id"
          onChangeFunc={this.onChangePlace}
          onInputChangeOptionFunc={this.onInputChangePlace}
        />
      </div>
    );
  }

  renderSelectedPlace(place) {
    return (
      <div className={styles.selectedPlace} key={place.id}>
        <div>{place.name}</div>
        <div
          style={{ marginLeft: 'auto', marginRight: '0px' }}
          onClick={() => this.onDeletePlace(place)}
        >
          <DeleteIcon
            style={{
              color: '#FF765F',
              cursor: 'pointer',
            }}
          />
        </div>
      </div>
    );
  }

  renderSelectedPlaces(selectedPlaces = []) {
    if (isEmpty(selectedPlaces)) return <div />;

    return (
      <div className={styles.selectedPlaces}>
        {selectedPlaces.map((sp) => {
          return this.renderSelectedPlace(sp);
        })}
      </div>
    );
  }

  render() {
    const { selectedPlaces = [], selectedType = {} } = cloneDeep(this.props);

    const showDeleteIcon = !isEmpty(selectedPlaces) ? true : false;
    return (
      <Modal open={this.props.isModifying} onClose={this.props.onCloseFunc} className={styles.root}>
        <div className={styles.list}>
          {this.renderTopPanel(showDeleteIcon, selectedType)}
          {this.renderTypes()}
          {this.renderPlaces()}
          {this.renderSelectedPlaces(selectedPlaces)}
          <div className={styles.saveButton}>
            <ACButton
              text={'Save'}
              icon={<SaveIcon />}
              iconLast={true}
              onClickFunc={this.props.onSaveMtePlacesFunc}
            />
          </div>
        </div>
      </Modal>
    );
  }
}
